import {
  getData,
  postData,
  putData,
  toQueryString,
} from '../../../shared/api/core';

export const getFilterOptions = (params) =>
  getData(`/voyage/filter-options${toQueryString(params)}`);

export const getShipments = (params) =>
  getData(
    `/voyage/shipment-details-aggregated?${new URLSearchParams(params).toString()}`
  );

const encodeBase64Param = (value) => {
  if (!value) return value;
  try {
    // btoa only handles Latin1; encodeURIComponent + unescape turns UTF-8 into Latin1 bytes
    return btoa(unescape(encodeURIComponent(value)));
  } catch {
    return value;
  }
};

export const getShipmentsPaged = (params) => {
  const encodedParams = { ...params };
  if (encodedParams.columnFilters) {
    encodedParams.columnFilters = encodeBase64Param(
      encodedParams.columnFilters
    );
  }
  if (encodedParams.sortModel) {
    encodedParams.sortModel = encodeBase64Param(encodedParams.sortModel);
  }
  return getData(
    `/voyage/shipment-details-aggregated/paged?${new URLSearchParams(encodedParams).toString()}`
  );
};

export const addVoyages = (data) => postData(`/voyage`, data);

export const updateVoyage = (id, data) => putData(`/voyage/${id}`, data);

export const getVoyageShipmentHistory = (voyageScheduleId) =>
  getData(`/voyage/shipments/${voyageScheduleId}/history`);

export const getVoyageWithShipmentsAggregated = (params) =>
  getData(
    `/voyage/with-shipments-aggregated?${new URLSearchParams(params).toString()}`
  );

// Display-only projection for the TBN alert banner — no shipments, no stock.
export const getTbnVoyages = (params) =>
  getData(`/voyage/tbn?${new URLSearchParams(params).toString()}`);

export const getVoyageWithShipments = (voyageId, params = {}) =>
  getData(
    `/voyage/with-shipments/${voyageId}?${new URLSearchParams(
      params
    ).toString()}`
  );

export const getVoyageScheduleHistory = (voyageScheduleId, startDate) =>
  getData(`/voyage/${voyageScheduleId}/history?date=${startDate}`);

export const getFullVoyageScheduleHistory = (voyageId) =>
  getData(`/voyage/${voyageId}/history`);

export const getVoyageHistoryDates = (voyageId) =>
  getData(`/voyage/${voyageId}/history/dates`);

export const getShipmentsGroupedByCountry = (params) =>
  getData(
    `/voyage/countries/summary?${new URLSearchParams(params).toString()}`
  );

export const getShipmentsGroupedByCountryMonthYearETD = (params) =>
  getData(
    `/voyage/countries/monthly-summary/etd?${new URLSearchParams(
      params
    ).toString()}`
  );

export const getShipmentsGroupedByCountryMonthYearETA = (params) =>
  getData(
    `/voyage/countries/monthly-summary/eta?${new URLSearchParams(
      params
    ).toString()}`
  );

export const getShipmentsGroupedByPortCountryMonthYearETD = (params) =>
  getData(
    `/voyage/ports/monthly-summary/etd?${new URLSearchParams(
      params
    ).toString()}`
  );

export const getShipmentsGroupedByPortCountryMonthYearETA = (params) =>
  getData(
    `/voyage/ports/monthly-summary/eta?${new URLSearchParams(
      params
    ).toString()}`
  );

export const getVoyageSummary = (params) =>
  getData(`/voyage/summary?${new URLSearchParams(params).toString()}`);

export const getQuartelyVoyageNumbersETD = (params) =>
  getData(
    `/voyage/quarterly-summary-etd?${new URLSearchParams(params).toString()}`
  );

export const getQuartelyVoyageNumbersETA = (params) =>
  getData(
    `/voyage/quarterly-summary-eta?${new URLSearchParams(params).toString()}`
  );

export const getVoyageMonthlyTableETD = (params) =>
  getData(`/voyage/summary-by-etd?${new URLSearchParams(params).toString()}`);

export const getVoyageMonthlyTableETA = (params) =>
  getData(`/voyage/summary-by-eta?${new URLSearchParams(params).toString()}`);

export const getVoyageStatistics = (params) =>
  getData(`/voyage/statistics?${new URLSearchParams(params).toString()}`);

export const getShipViewGroups = (params) =>
  getData(`/voyage/ship-view?${new URLSearchParams(params).toString()}`);

export const getVoyageGroup = (params) =>
  getData(`/voyage/group?${new URLSearchParams(params).toString()}`);

export const updateVoyageGroup = (data) => putData(`/voyage/group`, data);
